import { makeStyles } from "tss-react/mui";

interface IParams {
    isMobile: boolean;
}

export const useStyle = makeStyles<IParams>()((theme, props) => ({
    container: {
        paddingBottom: theme.spacing(12),
    },
    broadbandOfferContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "0 auto",
        width: props.isMobile ? "90%" : 450,
    },
    section: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    image: {
        width: "100%",
    },
    footer: {
        height: 75,
        width: props.isMobile ? "100%" : 550,
        backgroundColor: theme.palette.primary.main,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        bottom: 0,
    },
    footerContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        paddingInline: theme.spacing(4),
    },
    basketInfo: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        color: theme.palette.common.white,
    },
    cartIcon: {
        width: 24,
        height: 24,
        "& path": {
            fill: theme.palette.common.white,
        },
    },
    badge: {
        "& .MuiBadge-badge": {
            backgroundColor: theme.palette.quaternary.main,
            color: theme.palette.secondary.main,
            fontSize: 12,
            top: 4,
            right: 2,
            minWidth: 0,
            width: 16,
            height: 16,
        },
    },
    basketText: {
        color: theme.palette.common.white,
    },
    basketTextBold: {
        fontWeight: theme.typography.fontWeightRegular,
    },
    button: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
        transition: "opacity 0.3s",
        margin: theme.spacing(2),
        "&:hover": {
            backgroundColor: theme.palette.common.white,
            opacity: 0.8,
        },
    },
}));
